import { Component, OnInit, OnDestroy } from '@angular/core';
import { Question } from '../../models/Question';
import { QuestionService } from '../../services/question.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-view-questions',
  templateUrl: './view-questions.component.html',
  styleUrls: ['./view-questions.component.scss']
})
export class ViewQuestionsComponent implements OnInit, OnDestroy {

  public isOpen = false;
  public oneAtATime = true;
  public questions: Question[] = [];
  private alive = true;

  constructor(private questionService: QuestionService,
    public sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.questionService.viewQuestions()
    .takeWhile(() => this.alive)
    .subscribe(
      data => {
        this.questions = data;
      },
      err => {
          console.log('viewQuestion error:' + err._body);
      }
    );
  }

  public ngOnDestroy() {
    this.alive = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared-components/view-questions/view-questions.component.ts